// src/webideal-recruit/components/dashboard/ActiveJobs.jsx
import React from "react";
import { Briefcase } from "lucide-react";
import { Link } from "react-router-dom";
import { createRecruitUrl } from "../../Layout";

export default function ActiveJobs({ jobs, applications }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-900">Active Jobs</h3>
        <Link to={createRecruitUrl("Jobs")} className="text-sm text-indigo-600">
          View All →
        </Link>
      </div>

      <div className="space-y-4">
        {jobs.slice(0, 3).map((job) => {
          const count = applications.filter((a) => a.job_id === job.id).length;

          return (
            <div
              key={job.id}
              className="p-4 border border-slate-100 rounded-xl hover:bg-slate-50 transition"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
                  <Briefcase className="w-5 h-5 text-indigo-600" />
                </div>

                <div className="flex-1">
                  <p className="font-medium text-slate-900">{job.title}</p>
                  <p className="text-xs text-slate-500">{job.location}</p>
                </div>

                <span className="text-xs text-slate-500">{count} applicants</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
